'use client'

import { createFormHookContexts } from '@tanstack/react-form'

// Own module so fields.tsx and appForm.tsx can share these without a cycle.
export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts()
